module.exports = __webpack_public_path__ + "img/vn-dejun2.7384fcdc.png";